import { useLayoutEffect, useState } from "react";

import { cn } from "@/lib/utils";

function useIsMac() {
  const [isMac, setIsMac] = useState(false);

  useLayoutEffect(() => {
    // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect, react-hooks/set-state-in-effect
    setIsMac(navigator.userAgent.includes("Mac"));
  }, []);

  return isMac;
}

function Kbd({ className, children, ...props }: React.ComponentProps<"kbd">) {
  const isMac = useIsMac();

  return (
    <kbd
      data-slot="kbd"
      className={cn(
        "bg-slatea-4 dark:bg-slatedarka-4 text-slatea-normal pointer-events-none inline-flex h-5 w-fit min-w-5 select-none items-center justify-center gap-1 rounded-sm px-1 font-sans text-xs font-medium",
        "[&_svg:not([class*='size-'])]:size-3",
        "[[data-slot=tooltip-content]_&]:bg-slate-5 dark:[[data-slot=tooltip-content]_&]:bg-slatedark-4",
        "[[data-slot=tooltip-content]_&]:text-slate-normal",
        className,
      )}
      {...props}
    >
      {typeof children === "string"
        ? isMac
          ? children.replace("Meta", "⌘")
          : children.replace("Ctrl", "Meta")
        : children}
    </kbd>
  );
}

function KbdGroup({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <kbd
      data-slot="kbd-group"
      className={cn("inline-flex items-center gap-1", className)}
      {...props}
    />
  );
}

export { Kbd, KbdGroup };
